export type PageToken = number | 'ellipsis-start' | 'ellipsis-end';

/**
 * Page numbers to render, with ellipses. Always includes first and last page and
 * `siblings` pages on each side of the current page. Output length is stable
 * (2 * siblings + 5) once there are enough pages, so controls do not jump around.
 */
export function getPageTokens(current: number, totalPages: number, siblings = 1): PageToken[] {
  const slots = siblings * 2 + 5;
  if (totalPages <= slots) return Array.from({ length: totalPages }, (_, i) => i + 1);

  const left = Math.max(current - siblings, 1);
  const right = Math.min(current + siblings, totalPages);
  const showStartEllipsis = left > 3;
  const showEndEllipsis = right < totalPages - 2;

  if (!showStartEllipsis && showEndEllipsis) {
    const count = 3 + 2 * siblings;
    return [...Array.from({ length: count }, (_, i) => i + 1), 'ellipsis-end', totalPages];
  }
  if (showStartEllipsis && !showEndEllipsis) {
    const count = 3 + 2 * siblings;
    return [
      1,
      'ellipsis-start',
      ...Array.from({ length: count }, (_, i) => totalPages - count + i + 1),
    ];
  }
  const middle = Array.from({ length: right - left + 1 }, (_, i) => left + i);
  return [1, 'ellipsis-start', ...middle, 'ellipsis-end', totalPages];
}
